import { getLang } from "helpers/themeHelpers";

export const linkToCarfax = () => {
  const locale = getLang();
  return `/${locale}/${locale === "ar" ? "كارفاكس" : "carfax"}`;
};

export const linkToCarseer = () => {
  const locale = getLang();
  return `/${locale}/${locale === "ar" ? "كارسير" : "carseer"}`;
};
export const linkToMojaz = () => {
  const locale = getLang();
  return `/${locale}/${locale === "ar" ? "موجز" : "mojaz"}`;
};
export const linkToCarReportsPage = (lang) => {
  return `/${lang}/${lang === "ar" ? "تقارير-المركبات" : "car-reports"}`;
};

export const isACarReportLink = (uri) => {
  if (
    uri.includes("carseer") ||
    uri.includes("mojaz") ||
    uri.includes("carfax") ||
    uri.includes("كارفاكس") ||
    uri.includes("كارسير") ||
    uri.includes("موجز")
  )
    return true;
  return false;
};
